import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Asaysh from "./Asaysh";
import { change_Lang } from "../../../actions/Helper_action";
import {
  Create_Asayesh,
  Get_List_Scurety_Bills,
} from "../../../actions_agent/Invoice_action";

export class Asaysh_Form extends Component {
  render() {
    const { lang, change_Lang, Create_Asayesh, user } = this.props;
    return (
      <Fragment>
        <div className="container-fluid">
          <Asaysh
            lang={lang}
            change_Lang={change_Lang}
            Create_Asayesh={Create_Asayesh}
            Get_List_Scurety_Bills={this.props.Get_List_Scurety_Bills}
            user={user}
          />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.HelperReducer.lang,
    user: state.AuthReducer.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
    Create_Asayesh: (data) => dispatch(Create_Asayesh(data)),
    Get_List_Scurety_Bills: () => dispatch(Get_List_Scurety_Bills()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Asaysh_Form);
